import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  standalone: true,
  selector: 'crm-auto-complete',
  templateUrl: './auto-complete.component.html',
  imports: [CommonModule, FormsModule, AutoCompleteModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoCompleteComponent implements OnChanges {
  @ContentChild('headerTemplate') public headerTemplate;
  @ContentChild('itemTemplate') public itemTemplate;
  @ContentChild('groupTemplate') public groupTemplate;
  @ContentChild('selectedItemTemplate') public selectedItemTemplate;
  @ContentChild('footerTemplate') public footerTemplate;

  public _value: any;
  public _arrayValue: any[];
  public _endValue: any;

  @Input() public value: any | any[];
  @Output() public valueChange = new EventEmitter<any | any[]>();

  @Output() public completeMethod = new EventEmitter<{ originalEvent: any; query: string }>();

  @Input() public isError = false;
  @Input() public isWithStringValue = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public disabled = false;
  @Input() public inputStyle: string;
  @Input() public inputStyleClass: string;
  @Input() public panelStyleClass: string;
  @Input() public suggestions: any[];
  @Input() public field: string;
  @Input() public virtualScroll = false;
  @Input() public virtualScrollItemSize: number;
  @Input() public dataKey: string;
  @Input() public appendTo: string;
  @Input() public placeholder = '';
  @Input() public multiple = false;
  @Input() public dropdown = false;
  @Input() public autofocus = false;
  @Input() public showClear = false;

  public constructor(private readonly cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.value?.currentValue) {
      if (this.multiple) {
        this._arrayValue = this.value;
      } else {
        this._value = this.value;
        if (this.field && typeof this._value === 'string') {
          this._value = { [this.field]: this._value };
        }
      }
      this.cdRef.markForCheck();
    }
  }

  public changeValue(event: any | any[]) {
    if (
      (this.isWithStringValue || (typeof event !== 'string' && !this.isWithStringValue)) &&
      event !== this._endValue
    ) {
      this.valueChange.emit(event);
      this._endValue = event;
    }
  }

  public onClear() {
    if (this.showClear && this._value != null) {
      this.valueChange.emit(null);
      this._endValue = null;
    }
  }

  public onBlur() {
    if (!this.isWithStringValue) {
      setTimeout(() => {
        if (typeof this._value === 'string') {
          if (this.suggestions?.length && this.suggestions.findIndex((s) => s[this.field] === this._value) !== -1) {
            this._value = this.suggestions.find((s) => s[this.field] === this._value);
            if (this._endValue !== this._value) {
              this.valueChange.emit(this._value);
              this._endValue = this._value;
            }
          } else {
            this._value = null;
            if (this._endValue !== this._value) {
              this.valueChange.emit(null);
              this._endValue = null;
            }
          }
        }
      }, 250);
    }
  }
}
